import { Link } from 'react-router-dom';
import NewsletterForm from './NewsletterForm';

const columns = [
  {
    title: '内容分类',
    links: [
      { label: '情感风波', to: '/collections?category=romance' },
      { label: '事业争议', to: '/collections?category=career' },
      { label: '金钱纠葛', to: '/collections?category=money' },
      { label: '剧组幕后', to: '/collections?category=production' },
    ],
  },
  {
    title: '热门合集',
    links: [
      { label: '顶流恋情时间线', to: '/collections/top-love-timeline' },
      { label: '演员解约风波', to: '/collections/actor-contract-dispute' },
      { label: '古装剧换角内幕', to: '/collections/costume-drama-recast' },
      { label: '综艺剪辑争议', to: '/collections/variety-editing-row' },
    ],
  },
  {
    title: '关于站点',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '内容原则', to: '/about#principles' },
      { label: '合集库总览', to: '/collections' },
      { label: '常见问题', to: '/#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-50 mt-auto">
      <div className="w-full px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">看瓜爆料</span>
            </div>
            <p className="text-sm text-secondary-200 leading-relaxed max-w-md">
              把零散的瓜料按事件、人物与时间线打包成合集专题，系统吃透每个爆料的来龙去脉，一次看个够。
            </p>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-background-50 mb-3 label-font">
                订阅本周新专题
              </h4>
              <NewsletterForm />
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="text-sm font-semibold text-background-50 mb-4 label-font">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="text-sm font-semibold text-background-50 mb-4 label-font">联系</h4>
            <ul className="space-y-3 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                hello@kanguabaoliao.site
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-feedback-line"></i>
                </span>
                内容纠错
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300 label-font">
            © 2026 看瓜爆料 · 合集汇总专题。站内内容仅整理公开信息，不代表任何当事人立场。
          </p>
          <p className="text-xs text-secondary-300 label-font">
            理性吃瓜 · 拒绝网暴 · 尊重隐私
          </p>
        </div>
      </div>
    </footer>
  );
}